import _ from 'lodash'
import Util from 'services/Util'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      timeoutHandle: {}
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'allNotifications'
    })
  },
  methods: {
    showNotification: function (data) {
      if (!_.some(this.notifications, { title: data.title })) {
        this.createNotification(data)
        this.setTimeoutForNotificationRemoval()
      } else {
        window.clearTimeout(this.timeoutHandle)
        this.setTimeoutForNotificationRemoval()
      }
    },
    createNotification: function (data) {
      let notification = _.cloneDeep(data)
      notification.id = Util.guid()
      this.$store.dispatch('addNotification', notification)
    },
    setTimeoutForNotificationRemoval: function () {
      this.timeoutHandle = window.setTimeout(() => {
        this.$store.dispatch('removeNotification')
      }, 5000)
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/mixins/notifications.js